import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const InformationOutlineIcon = forwardRef<SVGSVGElement, IconProps>(function InformationOutlineIcon(
  { color = '', height = 18, width = 18, hasCursorPointer, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <g clipPath="url(#clip0_672_123298)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 0.923077C3.19609 0.923077 0.923077 3.19609 0.923077 6C0.923077 8.80391 3.19609 11.0769 6 11.0769C8.80391 11.0769 11.0769 8.80391 11.0769 6C11.0769 3.19609 8.80391 0.923077 6 0.923077ZM0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6ZM5.53846 3.53846C5.53846 3.28356 5.7451 3.07692 6 3.07692H6.00615C6.26105 3.07692 6.46769 3.28356 6.46769 3.53846C6.46769 3.79336 6.26105 4 6.00615 4H6C5.7451 4 5.53846 3.79336 5.53846 3.53846ZM4.92308 6C4.92308 5.7451 5.12971 5.53846 5.38462 5.53846H6C6.2549 5.53846 6.46154 5.7451 6.46154 6V8H6.61539C6.87029 8 7.07692 8.20664 7.07692 8.46154C7.07692 8.71644 6.87029 8.92308 6.61539 8.92308H6C5.7451 8.92308 5.53846 8.71644 5.53846 8.46154V6.46154H5.38462C5.12971 6.46154 4.92308 6.2549 4.92308 6Z"
          fill={color || 'currentColor'}
        />
      </g>
      <defs>
        <clipPath id="clip0_672_123298">
          <rect width="12" height="12" fill="transparent" />
        </clipPath>
      </defs>
    </SvgStyled>
  );
});
